import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RecurrenceSummaryComponent } from '@principle-theorem/ng-principle-shared';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { MarketingCampaign } from '@principle-theorem/principle-core';
import { IMarketingCampaign } from '@principle-theorem/principle-core/interfaces';
import { splitCamel, titlecase } from '@principle-theorem/shared';

@Component({
  selector: 'pr-campaign-enrolment-summary',
  templateUrl: './campaign-enrolment-summary.component.html',
  styleUrl: './campaign-enrolment-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgCommonModule, MatIconModule, RecurrenceSummaryComponent],
  host: { class: 'flex flex-col gap-4' },
})
export class CampaignEnrolmentSummaryComponent {
  campaign = input.required<IMarketingCampaign>();
  entryScope: Signal<string>;

  constructor() {
    this.entryScope = computed(() => {
      const reentryScope = MarketingCampaign.reentryScope(this.campaign());
      return titlecase(splitCamel(`${reentryScope}s`));
    });
  }
}
